import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useInfoPuesto } from './useInfoPuesto';
import DataPuesto from './DataPuesto';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import AnulaPuesto from './AnulaPuesto';
import { anulaPuesto } from '../../services/Monitor/MonitorService';

const InfoPuesto = () => {
    const {
        toast,
        cargaProyecto,
        proyecto,
        setProyecto,
        lstProyecto,
        cargaPuesto,
        puesto,
        setPuesto,
        lstPuesto,
        filas,
        cargaInfoPuesto,
        inputTextEditor,
        eliminaBodyTemplate,
        agregarFila,
        handleGuardar,
        procesando,
        estaCargando,
        customUploader,
        cancelOptions,
        uploadOptions, 
        mostrarAnula, setMostrarAnula, handleAnular, abreAnula,
        renderKey
    } = useInfoPuesto();

    

    return (
        <div className="card"> 
            <Toast ref={toast} />
            <Dialog visible={mostrarAnula} onHide={() => setMostrarAnula(false)} style={{ width: '60vw' }}>
                <AnulaPuesto puesto={puesto} onAnular={handleAnular} />
            </Dialog>
            <h5>Actualiza informacion de Puesto</h5>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <div className="field col-12 md:col-12">
                        {/* Body Principal */}
                        <div className="formgrid grid p-fluid mb-3">
                            <div className="field col-12 md:col-5">
                                <label htmlFor="cboProyecto">Proyecto:</label>
                                {cargaProyecto ? (
                                    <div className="flex align-items-center">
                                        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                    </div>
                                ) : (
                                    <Dropdown inputId="cboProyecto" value={proyecto} onChange={(evt) => setProyecto(evt.value)} options={lstProyecto} optionLabel="descripcion" placeholder="Elija un Proyecto" filter showClear />
                                )}
                            </div>
                            <div className="field col-12 md:col-5">
                                <label htmlFor="cboPuesto">Puesto:</label>
                                {cargaPuesto ? (
                                    <div className="flex align-items-center">
                                        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                    </div>
                                ) : (
                                    <Dropdown inputId="cboPuesto" value={puesto} onChange={(evt) => setPuesto(evt.value)} options={lstPuesto} optionLabel={(option) => `${option.sigla} - ${option.nombre}`} placeholder="Elija un Puesto" filter showClear />
                                )}
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button
                                    label={
                                        <span>
                                            Anular
                                            <br />
                                            Puesto
                                        </span>
                                    }
                                    onClick={abreAnula}
                                />
                            </div>
                            <div className="field col-12 md:col-11">
                                <DataTable value={filas} loading={cargaInfoPuesto}>
                                    <Column header="Denominativo" body={(rowData) => inputTextEditor(rowData, 'codigo')} />
                                    <Column header="Telefono" body={(rowData) => inputTextEditor(rowData, 'telefono')} />
                                    <Column header="Marca Rapida" body={(rowData) => inputTextEditor(rowData, 'marcaRapida')} />
                                    <Column header="Elimina" body={eliminaBodyTemplate} />
                                </DataTable>
                            </div>
                            <div className="field col-12 md:col-1">
                                <Button label="+" onClick={agregarFila} tooltip="Adicion Fila" />
                            </div>
                            <div className="field col-12 md:col-6"></div>
                            <div className="field col-12 md:col-6">
                                <Button label="Guardar cambios" onClick={handleGuardar} loading={procesando} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="field col-12 md:col-12">
                    <hr />
                </div>
                {/* DataTable */}
                <div className="field col-12 md:col-12">
                    <DataPuesto key={renderKey} />
                </div>
                <div className="field col-12 md:col-12">
                    <hr />
                </div>
                <div className="field col-12 md:col-2">
                    <span>{}</span>
                </div>
                <div className="field col-12 md:col-8">
                    <h5>Actualizar mediante Archivo Excel</h5>
                    <label>Seleccionar un archivo Excel con los datos de Contacto de los Puestos:</label>
                    <FileUpload
                        mode="advanced"
                        name="file"
                        url="/api/upload"
                        accept=".xlsx, .xls"
                        uploadLabel={estaCargando ? 'Procesando...' : 'Procesar archivo'}
                        maxFileSize={1000000}
                        chooseLabel="Seleccionar Excel"
                        customUpload={customUploader}
                        uploadHandler={customUploader}
                        cancelOptions={cancelOptions}
                        uploadOptions={uploadOptions}
                        cancelLabel="Cancelar"
                    />
                </div>
                <div className="field col-12 md:col-2">
                    <span>{}</span>
                </div>
            </div>
        </div>
    );
};

export default InfoPuesto;
